<div role="dialog" aria-labelledby="dialogTitle" tabindex="-1">
  <div class="modal-header">
    <h2 id="dialogTitle" class="modal-title module-title">{{"plan.title"|translate}}</h2>
    <button type="button" class="close" aria-label="Close" (click)="dismiss()" title="{{'dialog.box.close.tooltip'|translate}}">
      <esp-icon name="x"></esp-icon>
    </button>
  </div>
  <div class="modal-body">
    <div class="col-12">
      <div>
        <!-- Plan Name -->
        <div class="row">
          <div class='col-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 form-group'>
            <wfm-textbox #planName (wfmTextboxEvent)="setPlanName($event.target.value)" inputName="planName"
                         [wfmAutoComplete]="'off'"
                         (inputOnBlur)="checkPlanNameExists($event)" [maxLength]="32"
                         inputId="planName" [required]="true" [textValue]="planModel.planName"
                         label="{{'plan.label.name'|translate}}" hasFocus=true
            >
            </wfm-textbox>
          </div>
        </div>
        <!-- Forecast Source -->
        <div class="row">
          <div class='col-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 form-group'>
            <wfm-select #forecastSource selectName="forecastSource" selectId="forecastSource"
                        label="{{'plan.label.forecastsource'|translate}}" [items]="forecastSourceList"
                        placeHolder="{{'plan.label.forecastsource'|translate}}" [disabled]="!hasPlanNameWithLength()"
                        (wfmSelectEvent)="updateForecastSource($event)" [selectedItem]="selectedForecastSource"
            >
            </wfm-select>
          </div>
        </div>
        <!-- Forecast -->
        <div class="row">
          <div class='col-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 form-group'>
            <wfm-select #forecast selectName="forecast" selectId="forecast"
                        label="{{'plan.label.forecast'|translate}}" [items]="forecastList"
                        placeHolder="{{'plan.label.forecast'|translate}}" [showLoading]="_forecastListLoading"
                        [disabled]="!hasPlanNameWithLength()" (wfmSelectEvent)="updateForecast($event)" [selectedItem]="selectedForecast">
            </wfm-select>
          </div>
        </div>
        <!-- WEM Skills -->
        <div class="row">
          <div class='col-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 form-group'>
            <label id="wem-skills-label" for="wem-skills-select" class="input-label">
              {{'plan.cxone.wem.skills.read.only'|translate}}
              <span class="text-danger">*</span>
            </label>
            <!-- WEM Skills is a read-only display field (skills come from the
                 selected forecast and cannot be changed); aria-readonly conveys
                 that the value cannot be edited (WCAG 2.1.1 / 4.1.2).
                 [disabled]="!selectedForecast" is intentional: when no forecast
                 has been chosen there are no skills to display, so the field
                 has no interactive content and must not be openable. In that
                 state PrimeNG's disabled tabindex=-1 is correct behaviour —
                 there is nothing for keyboard/screen-reader users to reach.
                 Once a forecast is selected and skills are populated the field
                 becomes enabled, enters the tab order, and aria-readonly
                 prevents editing. Visual dimming when enabled is provided by
                 the .wem-skills-readonly CSS class. -->
            <p-multiselect placeholder=" " #skillsMultiSelect
                           inputId="wem-skills-select"
                           name="wemSkillsSelect"
                           [ariaLabel]="'plan.cxone.wem.skills.read.only' | translate"
                           [options]="wemSkillsList"
                           [(ngModel)]="selectedWemSkills"
                           [showToggleAll]="false"
                           [virtualScroll]="true"
                           [virtualScrollItemSize]="40"
                           [virtualScrollOptions]="virtualScrollOptions"
                           emptyFilterMessage="{{'search.no.results.msg'|translate}}"
                           [showHeader]="true"
                           [overlayOptions]="{showTransitionOptions: '0ms', hideTransitionOptions: '0ms'}"
                           [filter]="false"
                           optionLabel="value.label"
                           optionValue="value"
                           optionDisabled="value.disabled"
                           [disabled]="!selectedForecast"
                           aria-readonly="true"
                           styleClass="fullrow"
                           class="filterable wem-skills-readonly"
                           (click)="onMultiselectContainerClick($event, skillsMultiSelect)">
              <ng-template let-value pTemplate="selectedItems">
                <esp-multi-select-content [items]="value" emptyMessage="plan.cxone.wem.skills"> </esp-multi-select-content>
              </ng-template>
              <ng-template pTemplate="header">
                <esp-multi-select-filter [multiSelect]="skillsMultiSelect" [displaySelectOptions]="false" [readOnly]="true"></esp-multi-select-filter>
              </ng-template>
              <ng-template pTemplate="footer">
                <esp-multi-select-footer [multiSelect]="skillsMultiSelect"></esp-multi-select-footer>
              </ng-template>
              <ng-template let-item pTemplate="item">
                <esp-multi-select-item [item]="item"></esp-multi-select-item>
              </ng-template>
            </p-multiselect>
            <!--
              Stable aria-controls target for the combobox. It is NOT given
              role="listbox": an empty listbox in the accessibility tree is
              announced as "list box, 0 items" (and can snag the JAWS virtual
              cursor, collapsing the combobox on arrow keys). aria-controls only
              needs a valid IDREF to an existing element, so this stays an inert,
              visually hidden, role-less container that screen readers ignore.
            -->
            <div id="wem-skills-select_list" class="sr-only"></div>
          </div>
        </div>
        <!-- Profiles -->
        <div class="row">
          <div class='col-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 form-group'>
            <wfm-select #profile selectName="profile" selectId="profile"
                        label="{{'plan.cxone.profiles'|translate}}" [items]="profileList"
                        placeHolder="{{'plan.cxone.profiles'|translate}}" [showLoading]="_profileListLoading"
                        [disabled]="!selectedForecast" (wfmSelectEvent)="updateProfile($event)" [selectedItem]="selectedProfile">
            </wfm-select>
          </div>
        </div>
        <!-- Scheduling Units -->
        <div class="row">
          <div class='col-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 form-group'>
            <label id="su-label" for="su-select" class="input-label" data-testid="schedulingUnitsLabel">
              {{'plan.cxone.scheduling.units'|translate}}
              <span class="text-danger">*</span>
            </label>
            <p-multiselect placeholder=" " #suSelector
                           inputId="su-select"
                           name="suSelect"
                           [focusOnHover]="false"
                           [ariaLabel]="'plan.cxone.scheduling.units' | translate"
                           styleClass="fullrow"
                           class="filterable"
                           [options]="schedulingUnitList"
                           [(ngModel)]="selectedSUs"
                           [showToggleAll]="false"
                           [virtualScroll]="true"
                           optionLabel="value.label"
                           optionValue="value"
                           [virtualScrollItemSize]="40"
                           [virtualScrollOptions]="virtualScrollOptions"
                           (onChange)="updateSelectedSUs($event)"
                           emptyFilterMessage="{{'search.no.results.msg'|translate}}"
                           [showHeader]="true"
                           [overlayOptions]="{showTransitionOptions: '0ms', hideTransitionOptions: '0ms'}"
                           [disabled]="_suListLoading"
                           [filter]="false"
                           (click)="onMultiselectContainerClick($event, suSelector)">
              <ng-template let-value pTemplate="selectedItems">
                <esp-multi-select-content [items]="value" emptyMessage="plan.cxone.scheduling.units"> </esp-multi-select-content>
              </ng-template>
              <ng-template pTemplate="header">
                <esp-multi-select-filter [multiSelect]="suSelector"></esp-multi-select-filter>
              </ng-template>
              <ng-template pTemplate="footer">
                <esp-multi-select-footer [multiSelect]="suSelector"></esp-multi-select-footer>
              </ng-template>
              <ng-template let-item pTemplate="item">
                <esp-multi-select-item [item]="item"></esp-multi-select-item>
              </ng-template>
            </p-multiselect>
            <!--
              Stable aria-controls target for the combobox. It is NOT given
              role="listbox": an empty listbox in the accessibility tree is
              announced as "list box, 0 items" (and can snag the JAWS virtual
              cursor, collapsing the combobox on arrow keys). aria-controls only
              needs a valid IDREF to an existing element, so this stays an inert,
              visually hidden, role-less container that screen readers ignore.
            -->
            <div id="su-select_list" class="sr-only"></div>
          </div>
        </div>
        <!-- Start Day of Week -->
        <div class="row">
          <div class='col-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 form-group'>
            <wfm-select #sdow selectName="sdow" selectId="sdow"
                        label="{{'plan.start.day.of.week'|translate}}" [items]="startDayOfWeekList"
                        placeHolder="{{'plan.start.day.of.week'|translate}}" [showLoading]="_startDayOfWeekListLoading"
                        [disabled]="_startDayOfWeekDisabled" (wfmSelectEvent)="updateStartDayOfWeek($event)" [selectedItem]="selectedStartDayOfWeek">
            </wfm-select>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <div class="modal-buttons">
      <breeze-button buttonText="{{'plan.cancel.btn'|translate}}"
                     id="cancel-btn"
                     [isSecondary]="true"
                     (clicked)="dismiss()"></breeze-button>

      <breeze-button buttonText="{{'plan.create.btn'|translate}}"
                     id="create-plan-btn"
                     [isPrimary]="true"
                     [isDisabled]="!isPlanModelValid()"
                     (clicked)="createPlan()"></breeze-button>
    </div>
  </div>
</div>
